export default "__VITE_ASSET__bMGai35o__"